'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDashboardBuilderLegend, iconDashboardBuilderLegendTag } from '@ni/nimble-components/dist/esm/icons/dashboard-builder-legend';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDashboardBuilderLegend };
export { iconDashboardBuilderLegendTag };
export const NimbleIconDashboardBuilderLegend = wrap(IconDashboardBuilderLegend);